module.exports = __webpack_public_path__ + "img/authorize1-eg.a67cadb8.jpg";